import { render, staticRenderFns } from "./ProjectCardRes.vue?vue&type=template&id=e1339626&scoped=true&"
import script from "./ProjectCardRes.vue?vue&type=script&lang=js&"
export * from "./ProjectCardRes.vue?vue&type=script&lang=js&"
import style0 from "./ProjectCardRes.vue?vue&type=style&index=0&id=e1339626&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1339626",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VLayout,VRow})
